import React from 'react'
import { selectNavHeight } from "../../../../redux/navbar/navHeightSlice";
import { useSelector } from "react-redux";
import TestDueList from './TestsDueList'

const TestDuePage = () => {
    const navHeight = useSelector(selectNavHeight);
  
  return (
  <div  className="mx-auto w-full"
    style={{
      marginTop: navHeight,
      height: `calc(100vh - ${navHeight}px)`,
      overflow: "auto",
    }} >
      <TestDueList />
    </div>
  );
}

export default TestDuePage